import React from "react";
import { MdDownload } from "react-icons/md";

const CustomFooter = ({
  onExport,
  onPrint,
  onDownload,
  onEdit,
  onSign,
  showSignButton = true,
  signLabel = "SAVE TEAM SCORES",
  align = "between",
}) => {
  let justifyClass = "justify-content-between";
  if (align === "left") justifyClass = "justify-content-start";
  else if (align === "center") justifyClass = "justify-content-center";
  else if (align === "right" && !onDownload) justifyClass = "justify-content-end";

  // Determine which buttons to show
  const showDownloadButton = onDownload;
  const showExportButton = onExport && !onDownload;
  const showPrintButton = onPrint && !onDownload;
  const showEditButton = onEdit;

  return (
    <footer className={`d-flex ${justifyClass} bg_primary px-4 py-3 h-69`}>
      <div className="d-flex">
        {showDownloadButton && (
          <button
            className="btn btn_light pl-3 pr-4"
            onClick={onDownload}
            disabled={!onDownload}
          >
            <MdDownload size={18} className="mr-2" />
            <small>DOWNLOAD</small>
          </button>
        )}
        {showExportButton && (
          <button
            className="btn btn_light pl-3 pr-4 mr-3"
            onClick={onExport}
            disabled={!onExport}
          >
            <i className="fa fa-file-o pr-2"></i>
            <small>EXPORT</small>
          </button>
        )}
        {showPrintButton && (
          <button
            className="btn btn_light pl-3 pr-4 ml-3"
            onClick={onPrint}
            disabled={!onPrint}
          >
            <i className="fa fa-print pr-2"></i>
            <small>PRINT</small>
          </button>
        )}
      </div>
      {(showEditButton || showSignButton) && (
        <div>
          {showSignButton && (
            <button
              className="btn btn_light px-5 ml-3"
              onClick={onSign}
              disabled={!onSign}
            >
              <small>{signLabel}</small>
            </button>
          )}
          {showEditButton && (
            <button
              className="btn btn_outline_light px-5 ml-3"
              onClick={onEdit}
              disabled={!onEdit}
            >
              <small>EDIT</small>
            </button>
          )}
        </div>
      )}
    </footer>
  );
};

export default CustomFooter;
